'use strict';

/**
 * @function
 * @description gets the query parameter value from URL
 * @param {String} url the url to extra query string from
 * @param {String} parameter name
 */
const getQueryParameter = (url, parameterName) => {
    parameterName = parameterName.replace(/[[]/, '\[').replace(/[]]/, '\]'); /* eslint-disable-line */

    const regexPattern = '[\?&]' + parameterName + '=([^&#]*)';
    const regex = new RegExp(regexPattern);
    const results = regex.exec(url);

    if (results === null || (results && typeof (results[1]) !== 'string' && results[1].length)) {
        return '';
    } else {
        return decodeURIComponent(results[1]).replace(/\W/gi, ' ');
    }
};

module.exports = getQueryParameter;
